import { render, staticRenderFns } from "./addDecisionColumn.vue?vue&type=template&id=1359f42f&"
import script from "./addDecisionColumn.vue?vue&type=script&lang=js&"
export * from "./addDecisionColumn.vue?vue&type=script&lang=js&"
import style0 from "./addDecisionColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports